import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LEGACY_CATEGORY = 'Tools Launcher';

const TEXT_TO_911_EVENT_NAMES = {
  CARD_CLICK: 'tools_text_to_911_card_click',
  FORM_CLICK: 'tools_text_to_911_form_click',
};

export const trackTextTo911CardClick = irpVersion => {
  gspx.trackEvent({
    name: TEXT_TO_911_EVENT_NAMES.CARD_CLICK,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: 'AGENT511 Click on Reply to Text',
      Category: 'third party',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackTextTo911FormClick = (irpVersion, doesCallExistInQueue) => {
  const NEW_CHAT =
    'AGENT511 Click on Launch Chat (Initiate Chat w/ New Phone Number)';
  const TEXTBACK =
    'AGENT511 Click on Launch Chat (Textback Existing Phone Number)';
  const eventName = doesCallExistInQueue ? TEXTBACK : NEW_CHAT;

  gspx.trackEvent({
    name: TEXT_TO_911_EVENT_NAMES.FORM_CLICK,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: eventName,
      Category: 'third party',
      'Launched date': new Date(),
      irpVersion,
      doesCallExistInQueue,
    },
  });
};
